import { render, staticRenderFns } from "./RegisterPackFlow.vue?vue&type=template&id=5b04afcd&scoped=true&"
import script from "./RegisterPackFlow.vue?vue&type=script&lang=js&"
export * from "./RegisterPackFlow.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPackFlow.vue?vue&type=style&index=0&id=5b04afcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b04afcd",
  null
  
)

export default component.exports